// src/components/ui/sonner.tsx
import { memo } from "react";
import { useTheme } from "next-themes";
import { Toaster as SonnerToaster, toast } from "sonner";
import { LAYERS } from "@/utils/layers";

export { toast };

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

function ToasterImpl(props: ToasterProps) {
  const { theme = "system" } = useTheme();

  return (
    <SonnerToaster
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      offset={60}
      style={{ zIndex: LAYERS.TOAST }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export const Toaster = memo(ToasterImpl);
export default Toaster;
